import ReactSlider from 'react-slider';
import { scaleLinear } from '@visx/scale';

import { Box } from '@simplywallst/ui-core';

import { Track, Thumb, Pip, Label, Dot } from './styled';

interface Props {
  onChange: (value: number) => void;
  value: number | number[];
  min: number;
  max: number;
  step: number;
  labels: string[][];
}

const activeColor = '#abe2fb';
const disabledColor = '#e9e9e9';

const Slider = ({ onChange, min, max, step, value, labels }: Props) => {
  const scaleY = scaleLinear({
    domain: [min, max],
  });
  const isRange = typeof value !== 'number';
  return (
    <Box height="32px" position="relative" width="100%" paddingTop="x2">
      <ReactSlider
        min={min}
        max={max}
        step={step}
        // @ts-expect-error - FIXME
        value={value}
        renderTrack={(props, state) => (
          <>
            <Track
              {...props}
              background={
                state.index === (isRange ? 1 : 0) ? activeColor : disabledColor
              }
            />
            {labels.length &&
              state.index === 0 &&
              labels.map((n) => {
                const mark = parseFloat(n[0]);
                if (isNaN(mark)) return null;
                let active = false;
                if (typeof value === 'number') {
                  active = mark <= value;
                } else if (isRange) {
                  active =
                    mark >= value[0] && mark <= value[(value as []).length - 1];
                }
                let offsets = 0;
                if (n[1] === '-∞') offsets = -20;
                if (n[1] === '∞') offsets = 20;
                return (
                  <Pip
                    key={`slider-pip-${mark}-${n[1]}`}
                    left={(scaleY(mark) as number) * 100}
                  >
                    <Label offsets={offsets} active={active}>
                      {n[1]}
                    </Label>
                    <Dot active={active} />
                  </Pip>
                );
              })}
          </>
        )}
        renderThumb={(props) => <Thumb {...props} />}
        onChange={onChange}
      />
    </Box>
  );
};

export default Slider;
